import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/dropZone/styles.scss';export default {};